/* eslint-disable @typescript-eslint/naming-convention */
export const FULLY_UNAUTHENTICATED_APIS = {
  // Authentication API
  AUTH_LOGIN_URI: '/auth/authenticate/login',
  LOGIN_HEALTH_STATUS_URL: '/auth/authenticate/login/healthCheck',
  // Token API
  AUTH_REFRESH_URI: '/auth/authenticate/refresh',
  // Password API
  AUTH_FORGOT_PWD_URI: '/auth-sign-up/authenticate/forgotPassword',
  AUTH_FORGOT_PWD_CONFIRM_URI: '/auth-sign-up/authenticate/forgotPasswordConfirm',
  // Registration API
  AUTH_REGISTRATION_INIT_URI: '/auth-sign-up/register',
  AUTH_REGISTRATION_DETAILS_URI: '/auth-sign-up/register/detail/',
  AUTH_REGISTRATION_COMPLETE_URI: '/auth-sign-up/register/completeRegistrationAndAuthenticate/',
  AUTH_REGISTRATION_RESEND_URI: '/auth-sign-up/register/resendVerificationMail',
  AUTH_REGISTRATION_USECODE_URI: '/auth-sign-up/register/registrationCodeEnabled',
  // SSO API
  SSO_URI: '/auth/authenticate/sso/', // allow checking SSO enabled status
  // CDN
  CDN_URI: 'cdn.itonics.io',
  // Angular Specific
  ASSETS_PATH: '/assets/', // allow loading from the angular assets folder!
  // S3 permanent bucket
  S3_PERMANENT_URL: 'files-permanent-bucket'
} as const;

// Some APIs are mixed type and the rules which paths are or aren't authenticated are more complex
// --> return TRUE for if the url to be called is UNAUTENTICATED
export const PARTIALLY_UNAUTHENTICATED_APIS = {
  // Legal API
  LEGAL_CONTRACTS_URI: (url: string): boolean => url.endsWith('/legal/contracts')
} as const;
